<template>
    <div class="DocumentExplorer" v-observe-visibility="VisibilityChanged" style="display:flex;flex-direction:column; max-height:85vh;">
        <div ref="divtophalf">
            <h2>Document Explorer <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" /> <span v-b-tooltip.hover title="Hide/Show Filters"><font-awesome-icon :icon="ShowFilters ? 'eye' : 'eye-slash'" v-on:click="ToggleShowFilters()" class="pointer" /></span></h2>
            <p><font-awesome-icon :icon="['fa', 'info']" class="red" /> This system already has tens of thousands of documents, so some searches may take time.  The more narrow your search, generally, the faster the search results will be available.  For searches that return large datasets, you may experience performance issues with the site.</p>
            <div class="row" v-show="ShowFilters">
                <div class="col-xs-12">
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Dated On or After:</label>
                        <flat-pickr class="form-control" :config="DateInputConfigSchema" v-model="SearchFilters.DatedOnOrAfter"></flat-pickr>
                    </div>
                    <div class="form-group">
                        <label>Dated On or Before:</label>
                        <flat-pickr class="form-control" :config="DateInputConfigSchema" v-model="SearchFilters.DatedOnOrBefore"></flat-pickr>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Updated On or After:</label>
                        <flat-pickr class="form-control" :config="DateInputConfigSchema" v-model="SearchFilters.UpdatedOnOrAfter"></flat-pickr>
                    </div>
                    <div class="form-group">
                        <label>Updated On or Before:</label>
                        <flat-pickr class="form-control" :config="DateInputConfigSchema" v-model="SearchFilters.UpdatedOnOrBefore"></flat-pickr>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Author:</label>
                        <v-select label="text" :reduce="option => option.value" :options="EmployeeAuthorOptions" v-model="SearchFilters.EmployeeAuthorID"></v-select>

                    </div>
                    <div class="form-group">
                        <label>Document Status:</label>
                        <select class="form-control" v-model="SearchFilters.Status">
                            <option value=""></option>
                            <option value="Filed">Filed</option>
                            <option value="Submitted For Approvals">Submitted For Approvals</option>
                            <option value="Draft">Draft</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Chart Type:</label>
                        <select class="form-control" v-model="SearchFilters.ChartType">
                            <option value="ClientSubProgramMembership">Child File</option>
                            <option value="FosterResourceFamily">Family File</option>
                            <option value="FosterResourceParent">Foster Parent File</option>
                            <option value="Employee">Employee File</option>
                            <option value="EntityContact">Family Member File</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4">
                    <!--<label>Search Document By Keyword:</label>
            <div class="input-group">
                <b-form-input type="text" @keydown.enter.native="SearchPDFForKeyword" v-model="searchKeyword" class="form-control py-2 mr-1 pr-5" @input="RedrawTable()" />
                <span class="input-group-append">
                    <span class="btn ml-n5" style="z-index:100;">
                        <font-awesome-icon :icon="['fa', 'search']" @click="SearchPDFForKeyword" />
                    </span>
                </span>
            </div>-->
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search Document Results:</label>
                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4">
                    <p>Selected {{ SelectedDocumentsCount }} Documents (<span class="link-like" @click="SelectAllCheckboxes">Select All</span> / <span class="link-like" @click="UnselectAllCheckboxes">Unselect All</span>)</p>
                    <p v-if="SelectedDocumentsCount > 1 && SelectedDocumentsCount <= 50" class="link-like" @click="ViewSelectedDocuments">View Selected</p>
                    <p v-if="SelectedDocumentsCount > 50">(You cannot view more than 50 documents at a time)</p>
                </div>
                <div class="col-sm-4">
                    <p>Displaying {{NumberOfDocuments}} Records</p>
                </div>
            </div>
        </div>
        <div class="row" style="overflow:auto;">
            <vuetable :fields="DocumentTableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      :row-class="onRowClass"
                      class="vue-datatable"
                      ref="datatable"
                      :data-manager="DataManager"
                      id="documentexplorerdatatableid">

                <template slot="SelectCheckbox" scope="props">
                    <b-form-checkbox v-model="props.rowData.Checked" :value="true" :unchecked-value="false"></b-form-checkbox>
                </template>
                <template slot="Actions" scope="props">
                    <div class="horizontal-icons-padded">
                        <span><font-awesome-icon :icon="['fa', 'eye']" v-on:click="ViewDocument(props.rowData.PDFFileID, props.rowData.FormLabel, props.rowData.PDFFileName)" class="pointer" /></span>
                    </div>


                </template>
            </vuetable>
        </div>
        <DocumentViewer ref="document-viewer-modal-component" :reviewing="false" />
        <DocumentMiscOptions ref="document-misc-options-modal-component" />
    
</template>

<script>

    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import DocumentViewer from "./DocumentViewer.vue";
    import DocumentMiscOptions from "./DocumentMiscOptions.vue";

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faInfo } from '@fortawesome/free-solid-svg-icons';
    import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
    library.add(faEyeSlash);
    library.add(faInfo);
    import { faSearch } from '@fortawesome/free-solid-svg-icons';
    library.add(faSearch);

    //MIXINS
    import { TableScrollerSupport } from "../../../mixins/TableScrollerSupport.js";

    import { EventBus } from '../../../services/event-bus.js';
    export default {
        mixins: [TableScrollerSupport],
        created() {
            
        },
        props: [
        ],
        data: function () {
            return {
                SearchFilters: {
                    DatedOnOrAfter: "",
                    DatedOnOrBefore: "",
                    UpdatedOnOrAfter: "",
                    UpdatedOnOrBefore: "",
                    EmployeeAuthorID: "",
                    ChartID: "",
                    FormID: "",
                    Status: "Filed",
                    ChartType: "ClientSubProgramMembership"
                },
                DateInputConfigSchema: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
                NumberOfDocuments: 0,
                search: "",
                searchKeyword: "",
                Documents: [],
                SelectAllCheckbox: false,
                DocumentTableOptions: {
                    Fields: [
                        {
                            name: '__slot:SelectCheckbox',
                            title: 'Select',
                            sortField: 'Checked'
                        },
                        {
                            name: 'FormLabel',
                            title: 'Name',
                            sortField: 'FormLabel'
                        },
                        {
                            name: 'EffectiveDate',
                            title: "Date",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'EffectiveDate',
                        },
                        {
                            name: 'ChartName',
                            title: "Chart Name",
                            sortField: 'ChartName',
                        },
                        {
                            name: 'ChartType',
                            title: "Chart Type",
                            sortField: 'ChartType',
                        },
                        {
                            name: 'AuthorName',
                            title: "Author",
                            sortField: 'AuthorName',
                        },
                        {
                            name: 'DocumentModifiedDate',
                            title: "Last Modified",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'DocumentModifiedDate',
                        },
                        {
                            name: 'DocumentStatus',
                            title: "Status",
                            sortField: 'DocumentStatus',
                        },
                        {
                            name: '__slot:Actions',
                            title: 'Actions'
                        }
                    ]
                },
                EmployeeAuthorOptions: []
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetDocuments();
            },
            GetDocuments() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/Documents/DocumentSearch", this.SearchFilters, this.GetDocumentsSuccess, () => { }, true);
            },
            GetDocumentsSuccess(response) {
                this.Documents = response.data.data;
                this.$refs.datatable.refresh();
            },
            EditDocument(documentID) {
                this.$refs['document-editor-modal-component'].ShowExistingDocumentModal(documentID);
            },
            ViewDocument(pdfFileID, formLabel, documentName) {
                this.$refs['document-viewer-modal-component'].ShowViewerModal(pdfFileID, formLabel, documentName);
            },
            ViewSelectedDocuments() {
                let docIDs = this.Documents.filter(d => d.Checked == true).sort((a, b) => (a.SortIndex > b.SortIndex) ? 1 : -1).map(d => d.DocumentID);
                this.$refs['document-viewer-modal-component'].ShowViewerModalWithComboDocs(docIDs);
            },
            SelectAllCheckboxes() {
                this.Documents.filter(d => d.IsVisible).forEach(function (item) {
                    item.Checked = true;
                });
            },
            UnselectAllCheckboxes() {
                this.Documents.filter(d => d.IsVisible).forEach(function (item) {
                    item.Checked = false;
                });
            },
            OpenDocumentMiscOptions(subProgramID, chartID, authorEmployeeID, documentID) {
                this.$refs['document-misc-options-modal-component'].ShowModal(subProgramID, chartID, authorEmployeeID, documentID, false, false, true);
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            formatLongDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD ').format(fmt)
            },
            onRowClass(dataItem, index) {
                if (dataItem.IsRejected) {
                    return "document-rejected-row";
                } else {
                    return "";
                }
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.Documents);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        dataset = dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                        let indexNum = 0;
                        dataset.forEach(function (item) {
                            item["SortIndex"] = indexNum;
                            indexNum++;
                        });
                        return dataset;
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                        inputData[index]['IsVisible'] = true;
                    }
                    else {
                        inputData[index]['IsVisible'] = false;
                    }
                });
                this.NumberOfDocuments = visibleData.length;
                return visibleData;                  
            },
            GetEmployeeAuthorOptions() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/Documents/GetDocumentSearchAvailableAuthors", {}, this.GetEmployeeAuthorOptionsSuccess, () => { }, false);
            },
            GetEmployeeAuthorOptionsSuccess(response) {
                this.EmployeeAuthorOptions = response.data.data;
            },
            SearchPDFForKeyword() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/Documents/SearchPDFForKeyword", { Keyword: this.searchKeyword }, this.SearchPDFForKeywordSuccess, () => { }, true);
            },
            SearchPDFForKeywordSuccess(response) {
                this.Documents = response.data.data;
                this.$refs.datatable.refresh();
            }
            
        },
        components: {
            Vuetable,
            DocumentViewer,
            DocumentMiscOptions,
            flatPickr,
            vSelect
        },
        computed: {
            SelectedDocumentsCount: function () {
               // return this.Documents.filter(d => d.Checked == true).length;
            }
        },
        mounted() {
            this.GetEmployeeAuthorOptions();
        }
    }
</script>

<style scoped>
    .horizontal-icons-padded span {
        padding-right: 20px;
    }
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
        z-index:2; /*prevent clickable buttons to go over header*/
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>